<template>
  <div>
    <base-header class="pb-6" type="celcomblue">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0 text-white">Dashboard</h6>
        </div>
      </div>

    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">

      <stats-card class="" style="display:none">
                <!-- Card body -->
        <div class="row">
          <div class="col">
            <h5 class="card-title text-uppercase text-muted mb-0">Estado de tu envio</h5>
          </div>
          <div class="col-auto">
            <div class="icon icon-shape bg-celcomblue text-white rounded-circle">
              <i class="fas fa-paper-plane"></i>
            </div>
          </div>
        </div>

        <base-progress show-label
                        type="celcomblue"
                        :height="8"
                        :value="20"
                        label="Enviando ..."
                        :striped="true"
                        :animated="true" />

      </stats-card>

        <div class="row">
          <div :class="(user.customer.monthlyLimit && !user.customer.postpaid) ? 'col-sm-8' : 'col-sm-12'">
              <card>
                <div slot="header" class="row align-items-center">
                  <div class="col">
                    <h6 class="text-uppercase text-muted ls-1 mb-1">Envíos</h6>
                    <h5 class="h3 mb-0">Últimos 7 días</h5>
                  </div>
                </div>
                <bar-chart
                  :height="350"
                  ref="barChart"
                  :chart-data="barChart.chartData"
                  :extra-options="barChart.extraOptions"
                >
                </bar-chart>

              </card>
            </div>


           <div class="col-sm-4" :style="{
          'display':(user.customer.monthlyLimit && !user.customer.postpaid) ? 'block' : 'none'
          }">

            <card header-classes="bg-gradient-primary">
              <div slot="header" class="row align-items-center">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0 text-white">Comprar</h5>
                  <span class="h2 font-weight-bold mb-0 text-yellow text-uppercase">Bolsa SMS</span>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-white text-primary rounded-circle shadow">
                    <i class="fas fa-shopping-cart"></i>
                  </div>
                </div>
              </div>

              <div class="mb-3" v-for="products in productos" v-bind:key="products.productName">
                <base-button block outline type="primary" @click="irCompra" class="font-weight-light">{{ numberWithCommas(products.credits) }} SMS a <span class="font-weight-700">${{ numberWithCommas(products.amount) }}</span></base-button>
              </div>

            </card>
          </div>
        </div>

      <!-- End charts-->

      <!-- Card stats -->
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-4">
              <stats-card class="bg-gradient-info">
                <!-- Card body -->
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0 text-white">SMS Disponibles</h5>
                    <span class="h2 font-weight-bold mb-0 text-white">{{ numberWithCommas((getUserSub!=null) ? getUserSub.remainingSms :  user.remainingSms) }}</span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-white text-info rounded-circle shadow">
                      <i class="fas fa-mail-bulk"></i>
                    </div>
                  </div>
                </div>

              </stats-card>
            </div>
            <div class="col-sm-4">
              <a href="/contactos/lista-contactos">
                <stats-card class="bg-gradient-success">
                  <!-- Card body -->
                  <div class="row">
                    <div class="col">
                      <h5 class="card-title text-uppercase text-muted mb-0 text-white">Contactos Totales</h5>
                      <span class="h2 font-weight-bold mb-0 text-white">{{numberWithCommas(dataContactoSize)}}</span>
                    </div>
                    <div class="col-auto">
                      <div class="icon icon-shape bg-white text-success rounded-circle shadow">
                        <i class="fas fa-users"></i>
                      </div>
                    </div>
                  </div>

                </stats-card>
              </a>
            </div>
            <div class="col-sm-4">
              <a href="/contactos/blacklist">
                <stats-card class="bg-gradient-red">
                  <!-- Card body -->
                  <div class="row">
                    <div class="col">
                      <h5 class="card-title text-uppercase text-muted mb-0 text-white">Contactos Blacklist</h5>
                      <span class="h2 font-weight-bold mb-0 text-white">{{numberWithCommas(dataBacklist.length)}}</span>
                    </div>
                    <div class="col-auto">
                      <div class="icon icon-shape bg-white text-red rounded-circle shadow">
                        <i class="fas fa-user-slash"></i>
                      </div>
                    </div>
                  </div>

                </stats-card>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card bg-white border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0 text-dark">Resumen de últimos envíos</h5>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-white text-gray rounded-circle shadow">
                    <i class="fas fa-table"></i>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col">
                   <el-table class="table-responsive align-items-center table-flush table-striped"
                              header-row-class-name="thead-light"
                              :data="(dataEnvios.length > 5) ? dataEnvios.slice(0,5):dataEnvios ">
                        <el-table-column label="Nombre"
                                        prop="sendingName"
                                        min-width="200px"
                                        sortable>
                            <template v-slot="{row}">
                                <div class="media align-items-center">
                                    <div class="media-body">
                                        <a href="#!" @click="descargarReportSingle(row,true)" class="font-weight-600 mb-0 text-sm text-celcomblue">{{row.sendingName}}</a>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Fecha"
                                        prop="sendingDate"
                                        min-width="200px"
                                        sortable>
                            <template v-slot="{row}">
                                        {{ fechaFormato(row.sendingDate) }}
                            </template>
                        </el-table-column>

                        <el-table-column label="Contactos"
                                        min-width="150px"
                                        sortable>
                            <template v-slot="{row}">
                                        {{ (row.sendingCount)}}
                            </template>
                        </el-table-column>

                        <el-table-column label="Enviados"
                                        prop="amountShipped"
                                        min-width="150px"
                                        sortable>
                            <template v-slot="{row}">
                                          {{ row.amountShipped }}
                            </template>
                        </el-table-column>

                        <el-table-column label="Entregados"
                                        prop="sendingCount"
                                        min-width="175px"
                                        sortable>
                            <template v-slot="{row}">
                                          {{ row.sendingOk }}
                            </template>
                        </el-table-column>

                        <el-table-column label="No Entregados"
                                        prop="sendingNoOk"
                                        min-width="175px"
                                        sortable>
                            <template v-slot="{row}">
                                          {{ row.sendingNoOk }}
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4">
                <base-button tag="a" type="celcompink" href="/reportes/reporte-mt">
                  Ver más <i class="fas fa-arrow-circle-right text-pink"></i>
                </base-button>
              </div>

            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card bg-white border-0">
            <!-- Card body -->
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="card-title text-uppercase text-muted mb-0 text-dark">Resumen de listas creadas</h5>
                </div>
                <div class="col-auto">
                  <div class="icon icon-shape bg-white text-gray rounded-circle shadow">
                    <i class="fas fa-clipboard-list"></i>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col">
                <el-table class="table-responsive align-items-center table-flush table-striped"
                        header-row-class-name="thead-light"
                        :data="(dataContacto.length > 5) ? dataContacto.slice(0,5):dataContacto ">
                  <el-table-column label="Nombre"
                                   prop="name"
                                   min-width="250px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  <a href="#!" @click="irDetail(row,true)" class="font-weight-600 mb-0 text-sm text-celcomblue">{{row.name}}</a>
                              </div>
                          </div>
                      </template>
                  </el-table-column>
                  <el-table-column label="Fecha Creación"
                                   prop="created"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                                   {{ fechaFormato(row.created) }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Contactos"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                                   {{ (row.validos + row.invalidos)}}
                      </template>
                  </el-table-column>

                  <el-table-column label="Válidos"
                                   prop="validos"
                                   min-width="125px"
                                   sortable>
                      <template v-slot="{row}">
                                    {{ row.validos }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Inválidos"
                                   prop="invalidos"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                                    {{ row.invalidos }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Estado"
                                   prop="active"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                          <badge class="mr-4" :type="(row.active==true) ? 'success' : 'danger'">
                              <span class="status">{{ (row.active==true) ? "Activo" : "Inactivo" }}</span>
                          </badge>
                      </template>
                  </el-table-column>
                </el-table>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4">
                <base-button tag="a" type="celcompink" href="/contactos/nueva-lista">
                  Ver más <i class="fas fa-arrow-circle-right text-pink"></i>
                </base-button>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';
  import PieChart from '@/components/Charts/PieChart';

  // Components
  import BaseHeader from '@/components/BaseHeader';
  import BaseProgress from '@/components/BaseProgress';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  // Lists
  import ProgressTrackList from './ProgressTrackList';
  import MembersCard from '@/views/Widgets/MembersCard';
  import TaskList from '@/views/Widgets/TaskList';

  // Tables
  import LightTable from './LightTable';
  import VectorMapCard from '@/views/Widgets/VectorMapCard'


    import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui'
  import { BasePagination, Modal, Dialog } from '@/components';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload';
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  flatpickr.localize(Spanish);
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  import moment from 'moment';
  import XLSX from 'xlsx';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';

  import swal from 'sweetalert2';
  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora,dataReportEnvio,dataReportNoEnvio,getUserSub } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)


  export default {
    components: {
      LineChart,
      BarChart,
      PieChart,
      BaseHeader,
      BaseProgress,
      RouteBreadCrumb,
      StatsCard,
      TaskList,
      VectorMapCard,
      LightTable,
      ProgressTrackList,
      MembersCard,
      DropzoneFileUpload,
      BasePagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      Modal,
      Dialog,
      flatPicker
    },
    data() {
      return {
        user :getUser(),
        getUserSub : getUserSub(),
        currentPage: 1,
        dataContacto: [0],
        dataBacklist:[0],
        dataEnvios:[],
        listaContactos: [],
        selectedRows: [],
        listaNombre: "",
        contactGroup: {},
        contactSingle: {},
        dataContactoSize:0,
        dates: {
          inicioRep: "",
          finRep: horaAhora()
        },
        fileSingle: [],
        reporteLoad: false,
        barChart: {
          chartData: {
            datasets: [
              {
                label: 'Envíos',
                data: dataReportEnvio(),
                backgroundColor: '#2dce89',
                borderColor: '#32325d',
                borderWidth: 1
              },
              {
                label: 'No Entregados',
                data: dataReportNoEnvio(),
                backgroundColor: '#f5365c',
                borderColor: '#32325d',
                borderWidth: 1
              }
            ],
            labels: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
          },
          extraOptions: chartConfigs.barChartOptions,
        },
        redPieChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
              label: 'Sales',
              backgroundColor: [
                '#f5365c',
                '#11cdef',
                'rgba(255, 206, 86)',
                '#2dce89',
                '#5e72e4',
                '#fb6340'
              ],
              data: [25, 20, 30, 22, 17, 29]
            }]
          }
        },
        productos: {}
      };
    },

    methods:{


  descargarReportSingle(row) {

      this.$loading.show()   //delay default is 300ms

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "start_date":moment(Date.now() - 7 * 24 * 3600 * 1000).format('YYYY-MM-DD').toString(),
        "sendingsms_id":row.sendingSmsId.toString(),
        "report_name":row.sendingName,
        "time_expired":horaAhora(),
      }

      console.log(js);

      window.open(Config.url_service+Config.report_excel_report + encodeURIComponent(encryptAES(js)))

      self.$loading.hide()

      },
      irDetail(row){


          localStorage.setItem('listcontact_init', JSON.stringify(row));

          window.location.href="/contactos/lista-contactos"

      },

      obtenerReporteEnvio() {

          let self = this;
          let user = (getUserSub()!=null) ? getUserSub() :getUser();

          var arr=[];

          let js = {
            "start_date":moment( moment(Date.now() - 7 * 24 * 3600 * 1000).format('YYYY-MM-DD h:mm:ss')).valueOf().toString(),
            "end_date": moment(moment().format('YYYY-MM-DD h:mm:ss')).valueOf().toString() ,
            "global_report":false,
            "time_expired":horaAhora(),
            "customer_user":encodeURIComponent(JSON.stringify(user)),
          }

          console.log(js);

          var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

          Vue.axios.post(Config.url_service+Config.report_available, body, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          })
            .then(function (response) {
                console.log(response)

                if (response.data.response === "200") {
                  console.log(response.data.data);

                  self.dataEnvios = response.data.data.sort((a, b) => (a.idSending < b.idSending) ? 1 : -1)


                } else {
                  console.log("No se encontraron registros envios para reporte home");

                }

            })
            .catch(function (error) {
              console.log("No se encontraron registros envios para reporte home",error);

            });

          },

      irCompra(){


        window.location.href="/cuenta/comprar-creditos"

      },
       fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD HH:mm:ss');
      },

      obtenerLista() {


      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();


      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.contact_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {
              console.log(response.data.data);

              self.dataContacto = (response.data.data.length<=9) ? response.data.data : response.data.data.slice(0,8);

              self.dataContactoSize = response.data.data.length;

            } else {
              console.log("No se encontró lista");

            }


        })
        .catch(function (error) {
            console.log("No se encontró lista",error);

        });

      },
      obtenerListaBlack() {


      let self = this;

      let js = {
        "time_expired":horaAhora(),
        "customer_user":encodeURIComponent(JSON.stringify(self.user))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.blacklist_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {
              console.log(response.data.data);

              self.dataBacklist = response.data.data;
            } else {
              console.log("No se encontró lista");

            }


        })
        .catch(function (error) {
            console.log("No se encontró lista",error);

        });

      },
      obtenerProducts() {

      //this.$loading.show();   //delay default is 300ms

      let self = this;
      let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer)),
        "email": "",
        "password": "",
        "userPhone": "",
        "plan": "",
        "transaction": ""
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.payment_products, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response);

            if (response.data.response === "200") {

              self.productos = response.data.data;
              console.log(response.data.data);

            } else {
              console.log("No se encontraron productos");
              alert("No se encontraron productos");

            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontraron productos",error);
            alert("No se encontraron productos");
            self.$loading.hide();
        });

      },
      numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }



    },

    mounted(){

      this.obtenerLista();
      this.obtenerListaBlack();
      this.obtenerReporteEnvio();
      this.obtenerProducts();

    }
  };
</script>
<style></style>
